module.exports = __webpack_public_path__ + "c42521451a354acd477c55e962e7715d.pdf";